// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__GshdZ","title":"InfoRow_title__QQs9X"};